import {ILoginRequest, ILoginResponse} from "@/src/interfaces/auth.interface";
import axiosInstance from "@/src/lib/axios";

class AuthService {
    private readonly baseEndpoint = "/public"
    // Matches routes/api.php → Route::group(['prefix' => 'auth', 'middleware' => ['auth:sanctum']])
    private readonly authEndpoint = "/auth"

    /**
     * Authenticates a user and returns the user + token payload.
     * Adjust the path below to match your Laravel route (e.g. "/login" or "/auth/login").
     */
    async login(payload: ILoginRequest): Promise<ILoginResponse> {
        const { data } = await axiosInstance.post<ILoginResponse>(
            `${this.baseEndpoint}/login`,
            payload
        )
        return data
    }

    /**
     * Revokes the current Sanctum access token (POST /auth/logout).
     * Requires the Authorization bearer token, so this must run before the
     * token is cleared client-side.
     */
    async logout(): Promise<void> {
        await axiosInstance.post(`${this.authEndpoint}/logout`)
    }
}

// Singleton export — one instance shared across the app
export const authService = new AuthService()